import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 16182 22947"
    {...props}
  >
    <path
      d="M11881 12511c-582 691-1222 1235-1920 1632v-2918c403-310 742-706 1017-1189 364-639 549-1393 549-2259 0-697-95-1346-285-1937s-459-1103-807-1536c-146-184-304-351-474-502V118c485 118 946 278 1381 481 1040 480 1917 1187 2629 2106 713 923 1256 2084 1641 3489 380 1398 570 2987 570 4755 0 1979-200 3721-601 5230-407 1510-987 2777-1758 3806-771 1024-1689 1784-2760 2285-352 165-719 302-1102 412v-3619c215-207 412-442 590-704 744-1103 1187-3050 1330-5848zm-5660 2409c-750-61-1459-242-2131-541-839-374-1567-902-2179-1578-612-675-1087-1462-1415-2364C164 9534 0 8590 0 7603c0-1067 185-2069 560-3025 369-955 902-1778 1588-2480 692-702 1515-1246 2470-1642C5125 249 5659 97 6221 0v3252c-396 210-758 517-1085 920-681 839-1019 1947-1019 3331 0 1366 338 2459 1019 3277 321 384 683 676 1085 879v3261zm0 8027c-853-108-1622-339-2305-693-992-506-1747-1140-2259-1895-517-760-775-1488-775-2185 0-432 158-818 480-1161 322-337 728-506 1224-506 454 0 861 126 1219 380 365 248 634 628 824 1134 227 618 602 1114 1130 1489 148 106 302 197 462 274v3163z"
      style={{
        fill: "#2b2a29",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
